module.exports = __webpack_public_path__ + "static/media/Presidente.dd01a646.png";